import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';

const LANGUAGES = [
  { code: 'az', label: 'Azərbaycanca', short: 'AZ', flag: '🇦🇿' },
  { code: 'en', label: 'English', short: 'EN', flag: '🇬🇧' },
  { code: 'tr', label: 'Türkçe', short: 'TR', flag: '🇹🇷' },
  { code: 'ru', label: 'Русский', short: 'RU', flag: '🇷🇺' },
];

const LanguageSwitcher = ({ position = 'top-right' }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const positionClass = {
    'top-right': 'fixed top-4 right-4',
    'top-left': 'fixed top-4 left-16',
    'inline': 'relative',
  }[position] || 'fixed top-4 left-16';

  return (
    <div ref={ref} className={`${positionClass} z-50`} data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="lang-switcher-btn"
        data-testid="language-switcher-toggle"
        aria-label="Language"
      >
        <Globe size={16} className="text-yellow-300" />
        <span className="font-semibold tracking-wide">{current.short}</span>
      </button>
      {open && (
        <div className="lang-switcher-menu" data-testid="language-switcher-menu">
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`lang-switcher-item ${l.code === i18n.language ? 'active' : ''}`}
              data-testid={`language-option-${l.code}`}
            >
              <span style={{ fontSize: 16 }}>{l.flag}</span>
              <span className="flex-1 text-left">{l.label}</span>
              {l.code === i18n.language && <Check size={14} className="text-yellow-300" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
